<template>
  <div class="passenger-wrapper">
    <progress-bar :activeIndex="1" />
    <div class="container">
      <div class="info-panel">
        <div class="passenger-info card-container">
          <div class="module-title mb-16">乘机人信息</div>
          <div class="passenger-list" v-if="comPassengers.length">
            <div :class="['passenger-item', selectedIds.some(v => v == item.id) ? 'active' : '']" v-for="(item, index) in comPassengers" :key="index" @click="selectPassenger(item.id)">
              {{ item.name }}
            </div>
          </div>
          <PassengerForm
            ref="passengerFormRef"
            :passengers="passengerForms" 
            :depFlightDate="depFlightDate" 
            :product="storageData && storageData.product || {}" 
            @delete="deletePassenger"
            :searchFilter="storageData && storageData.searchFilter"
          />
        </div>
        <div class="card-container" style="margin-top: 16px">
          <div class="module-title">联系人</div>
          <el-row :gutter="24">
            <el-col :span="12">
              <div class="contact-info" style="margin-left: 10px">
                <el-input placeholder="请输入手机号" ref="contactMobile" maxlength="11" v-model="contact.mobile"></el-input>
                <span style="font-size: 12px; color: #aaa; display: block; padding-top: 15px;">
                  <i class="el-icon-info"></i>
                  订单信息将发送到此手机号，请确认信息正确
                </span>
              </div>
            </el-col>
            <el-col :span="12">
              <el-input placeholder="请输入邮箱(选填)" ref="contactEmail" maxlength="50" v-model="contact.email"></el-input>
            </el-col>
          </el-row>
          
        </div>
        <div class="card-container" style="margin-top: 16px">
          <div class="module-title">预订须知</div>
          <div class="booked-ticket-body-1">
            <div class="no-padding no-border" style="display: inline-block; margin-top: 8px">
              <el-checkbox v-model="readChecked">我已阅读</el-checkbox>
              <a v-for="(value, key) in orderNeedKnows" :key="key" class="link link-sm" target="_blank" @click="$refs.aliasdialog.showDialog(key, value)">
                {{ value }}
              </a>
            </div>
          </div>
        </div>

        <button class="next-step" @click="createOrder" v-loading="loading">下一步</button>
      </div>
      <IntFeePanel :journeySegments="storageData && storageData.journeySegment || []" :payTotalInfo="payTotalInfo" :productInfo="storageData && storageData.product" />
    </div>

    <aliasViewDialog ref="aliasdialog"></aliasViewDialog>
  </div>
</template>

<script>
import Vue from "vue";
import { queryDict, searchtraveler, queryNoticeList, createIntOrder } from "@/api/newsapi";
import ProgressBar from "@/components/ProgressBar";
import aliasViewDialog from "@/components/AliasViewDialog";
import PassengerForm from "./components/PassengerForm.vue";
import { CURRENT_USER } from "@/store/mutation-types";
import { getPassType } from '@/utils/index.js';
import IntFeePanel from "../components/intFeePanel.vue";
import { defaultPassInfo, messageMap } from './config.js'
export default {
  components: { ProgressBar, aliasViewDialog, PassengerForm, IntFeePanel },
  data() {
    return {
      comPassengers: [],
      selectedIds: [],
      passengerForms: [ Object.assign({}, defaultPassInfo) ],
      contact: {
        mobile: "",
        email: "",
      },
      readChecked: false,
      orderNeedKnows: [],
      loading: false,
      storageData: null,
      payTotalInfo: {}
    };
  },

  computed: {
    flightSegment() {
      const list = []
      this.storageData?.journeySegment.map((item, index) => {
        if(item.flightSegment?.length) {
          const flights = item.flightSegment.map(v => ({ ...v, journeyType: item.journeyType, journeyTypeDesc: item.journeyTypeDesc }))
          list.push(...flights)
        }
      })
      return list
    },
    depFlightDate() {
      return this.flightSegment[this.flightSegment.length - 1]?.depDate
    },
    carryChild() {
      return this.storageData?.searchFilter?.carryChild
    }
    
  },

  watch: {
    passengerForms: {
      handler(val) {
        this.payTotalInfo = this.calcTotalInfo(val)
      },
      deep: true
    }
  },

  mounted() {
    this.loadTraveler();
    this._queryOrderNeedKnowDictKeys();
    const _storageData = sessionStorage.getItem('INT_FLIGHT_ITEM')
    this.storageData = _storageData ? JSON.parse(_storageData) : null;
    console.log('xxxxxxxxxxx-storageData', this.storageData);
  },

  methods: {
    _queryOrderNeedKnowDictKeys() {
      queryNoticeList({ key: "INT_BOOK_NOTICE_RULE_ALIAS_PC" }).then(res => {
        if (res.success) {
          this.orderNeedKnows = JSON.parse(res.data);
        }
      });
    },
    async loadTraveler() {
      const res = await searchtraveler({ t: { pageSize: 100 } });
      if (res.success) {
        const passengers = res.data?.data || [];
        // 筛选出护照和电子护照的乘客
        const list = passengers.filter(v => v.certificateType == 'PP' || v.certificateType == 'IP');
        // 最多展示15个可选乘客
        this.comPassengers = list.length > 15 ? list.slice(0, 15) : list;
      }
    },
    selectPassenger(id) {
      const index = this.selectedIds.findIndex(v => v == id);
      if (index > -1) { // 取消选中
        this.selectedIds.splice(index, 1);
        const formIndex = this.passengerForms.findIndex(v => v.id == id);
        if (formIndex > -1) {
          this.passengerForms.splice(formIndex, 1);
        }
        if(this.passengerForms.length == 0) {
          this.passengerForms.push(Object.assign({}, defaultPassInfo))
        }
      } else { // 选中
        const passenger = this.comPassengers.find(v => v.id == id);
        if (passenger) {
          const newPassenger = this.generateNewPassenger(passenger);
          const priceInfo = this.getShowPrice(passenger.paxType);
          newPassenger.priceInfo = priceInfo;
          this.passengerForms.push(newPassenger);
          this.selectedIds.push(id);
          this.$refs.passengerFormRef?.validNewPassenger(newPassenger, () => {
            this.$nextTick(() => {
              // 取消新增的乘客的选中状态
              this.passengerForms.pop()
              this.selectedIds.pop()
            })
          });
        }
      }
    },
    deletePassenger(id) {
      const index = this.selectedIds.findIndex(v => v == id);
      if (index > -1) this.selectedIds.splice(index, 1);
    },

    async createOrder() {
      const valid = this.validate(this.passengerForms)
      if(valid) {
        this.loading = true;
        const params = this.generateRequestParams();
        console.log('params', params);
        try {
          const res = await createIntOrder(params);
          if(res && res.success) {
            const { serialNo } = res.data;
            this.$router.push({ path: `/intOrderReview/${serialNo}` });
          } else {
            /* 判断实名认证 */
            if (res.errorCode == "07016") {
              // 弹出
              const tips = "很抱歉，您还没完成实名认证，可登录“湖南航空”小程序中会员中心-实名认证中完成认证";
              this.$alert(tips, "温馨提示", {
                confirmButtonText: "知道了",
                callback: (action) => {},
              });
            } else {
              this.$message.error(res.errorMessage || '创建订单失败');
            }
          }
        } catch (error) {
          console.log(error);
        } finally {
          this.loading = false;
        }
      }
    },


    validate(passengerForms) {
      // 校验参数
      if (!this.readChecked) {
        this.$alert("请先阅读并同意相关协议", "温馨提示", {
          confirmButtonText: "知道了",
          callback: (action) => {},
        });
        return false;
      }
      const chdCount = passengerForms.filter(v => v.type == 'CHD').length;
      const adtCount = passengerForms.filter(v => v.type == 'ADT').length;
      if (chdCount && adtCount && (chdCount > adtCount * 2)) {
        this.$message({ message: "儿童数不能超过成人数的2倍", type: "warning" });
        return false;
      }
      if(passengerForms.length == 1 && chdCount == 1) {
        this.$message({ message: "2 ~ 12岁儿童不能单独购买乘机", type: "warning" });
        return false
      }

      if(!this.carryChild && chdCount) {
        this.$refs.passengerFormRef?.childNoticeShow()
        return false
      }

      for (let i = 0; i < passengerForms.length; i++) {
        const form = passengerForms[i];
        const validFields = Object.keys(messageMap)
        const emptyField = validFields.find(field => !form[field])
        // 校验必填
        if(emptyField) {
          this.$message({ message: `第${i+1}位乘客 ${messageMap[emptyField]}`, type: "warning" });
          return false
        }

        const nameReg = /^[A-Za-z]+$/;
        if(!nameReg.test(form.firstName) || !nameReg.test(form.lastName)) {
          this.$message({ message: `第${i+1}位乘客 英文姓名只能包含英文字符`, type: "warning" });
          return false
        }

        // 校验格式
        const certNoReg = /^(?=.*[A-Za-z])[A-Za-z0-9]{5,15}$/
        if(!certNoReg.test(form.certNo)) {
          this.$message({ message: `第${i+1}位乘客 证件号限5-15位字母数字组合`, type: "warning" });
          return false
        }
        // 1开头的11位数字
        const phoneReg = /^1\d{10}$/
        if(!phoneReg.test(form.mobile)) {
          this.$message({ message: `第${i+1}位乘客 请输入11位手机号`, type: "warning" });
          return false
        }
      }
      if(!this.contact.mobile) {
        this.$message({ message: `联系人手机号不能为空`, type: "warning" });
        return false
      }
      const mobileReg = /^1\d{10}$/
      if(this.contact.mobile && !mobileReg.test(this.contact.mobile)) {
        this.$message({ message: `联系人手机号格式不正确`, type: "warning" });
        return false
      }
      const emailReg = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/
      if(this.contact.email && !emailReg.test(this.contact.email)) {
        this.$message({ message: `联系人邮箱格式不正确`, type: "warning" });
        return false
      }
      return true
    },

    generateRequestParams() {
      const { product = {}, snapshotCode, searchFilter } = this.storageData;
      const currentUser = Vue.ls.get(CURRENT_USER);
      console.log('currentUser', currentUser);
      const params = {
        snapshotCode: snapshotCode,
        requestSegment: searchFilter,
        orderInfo: {
          orderAmount: this.payTotalInfo.totalAmount,
          mobile: this.contact.mobile,
          email: this.contact.email,
          tripType: searchFilter.tripType,
          memberId: currentUser.memberId,
        },
        passengerList: this.passengerForms,
        fareGroupKey: product.productKey,
      }
      return params
    },

    getShowPrice(passType) {
      const passengerPrice = this.storageData?.product?.passengerPrice || [];
      const priceInfo = passengerPrice.find(item => item.passengerType == passType);
      return priceInfo || passengerPrice?.[0] || {}
    },

    calcTotalInfo(passengerForms) {
      const adtPassengers = []
      const chdPassengers = []
      const infantPassengers = []
      passengerForms.forEach(item => {
        if (item.type == 'ADT') {
          adtPassengers.push(item)
        } else if (item.type == 'CHD') {
          chdPassengers.push(item)
        } else if (item.type == 'INF') {
          infantPassengers.push(item)
        }
      })
      const passengerGroupList = [
        { passengerType: 'ADT', passengerTypeDesc: '成人', count: adtPassengers.length, ...this.getShowPrice('ADT') },
        { passengerType: 'CHD', passengerTypeDesc: '儿童', count: chdPassengers.length, ...this.getShowPrice('CHD') },
        { passengerType: 'INF', passengerTypeDesc: '婴儿', count: infantPassengers.length, ...this.getShowPrice('INF') },
      ]
      
      const totalAmount = passengerGroupList.reduce((acc, cur) => {
        return acc + (cur.totalAmount * cur.count)
      }, 0)
      const result = { totalAmount, passengerGroupList: passengerGroupList.filter(v => v.count > 0) }
      return result
    },

    generateNewPassenger(passenger) {
      const newPassenger = {
        id: passenger.id,
        firstName: passenger.firstName,
        lastName: passenger.lastName, 
        birthday: passenger.birthday,
        gender: passenger.sex,
        mobile: passenger.phone, 
        certNo: passenger.certificateNo,
        certType: passenger.certificateType,
        certIssuePlace: passenger.certIssuePlace,
        certExpired: passenger.certExpired,
        nationality: passenger.nationality,
        type: passenger.paxType
      }
      return newPassenger
    }
  }
};
</script>

<style lang="less" scoped>
.passenger-wrapper {
  background-color: #f9f9f9;
  .container {
    position: relative;
    display: flex;
    padding: 16px 0;
    gap: 16px;
    .module-title {
      font-weight: bold;
      font-size: 16px;
      color: #4d4e4e;
    }
    .mb-16 {
      margin-bottom: 16px;
    }
    .info-panel {
      width: 756px;
      .card-container {
        background: #fff;
        padding: 16px;
        border-radius: 8px;
      }
      .passenger-info {
        .passenger-list {
          padding: 0 0 12px;
          display: flex;
          gap: 14px;
          flex-wrap: wrap;
          .passenger-item {
            width: 100px;
            padding: 0 6px;
            line-height: 35px;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: keep-all;
            text-align: center;
            position: relative;
            border: 1px solid #aaa;
            border-radius: 6px;
            cursor: pointer;
            transition: all ease 0.2;
            // user-select: none;
          }
          .passenger-item.active {
            border: 1px solid #d70039;
            color: #d70039;
            &::after {
              content: "";
              background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAzklEQVQ4T9WSPU5CARCEvzmGN7GiR2IhCSSW2tEZbKSD3oaEgsbE0pbKCkoTe2/ACWhpPvOSBwHk74XKbXdndndmwoWVC/H8QwJ1CFwlaRfvV3pBHQDXQDvJohKB2gVaJXi+En99gVo0l0kmu86oj0APuEvys9nfJLgH3oGbJNPVkNoE3oBGkq9d8i0N1AfgtST5VmvADLhN8rkvM39EVDvAC1AvwU9JPg4Fbq8L6jNQXDNOMjqW1oM2qv0k/VNRr5SDszQ4tfGoC1XBxfwvSSg7EfS/AH8AAAAASUVORK5CYII=);
              background-size: cover;
              width: 12px;
              height: 12px;
              background-color: #d70039;
              position: absolute;
              border-radius: 6px 0 0 0;
              bottom: 0;
              right: 0;
            }
          }
        }
      }
    }
  }

  .booked-ticket-body-1 {
    padding: 5px 18px;
    font-size: 14px;
    background: #ffffff !important;
    .link-sm {
      font-weight: bold;
      text-decoration: underline;
      color: #009ed0;
      margin: 0 3px;
    }
  }
  .next-step {
    width: 100%;
    height: 53px;
    border: 0;
    background-color: #d70039;
    color: #fff;
    font-size: 16px;
    margin: 42px 0 53px;
    border-radius: 5px;
    cursor: pointer;
    &:hover {
      background-color: #e60039;
    }
  }

  .next-step:active {
    background-color: #d70039;
  }
}
</style>
